import script from "./AddMandateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddMandateModal.vue?vue&type=script&setup=true&lang=js"

import "./AddMandateModal.vue?vue&type=style&index=0&id=58096948&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58096948"]])

export default __exports__